import { Col, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";

const ViewContainerTypeModal = (props) => {

    const singleLogisticsContainerTypeData = props.singleLogisticsContainerTypeData;

    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Container Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Unit Code</label>
                                        <span>{singleLogisticsContainerTypeData[0]?.UnitCode || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Description</label>
                                        <span>{singleLogisticsContainerTypeData[0]?.Description || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Length</label>
                                        <span>{singleLogisticsContainerTypeData[0]?.Length || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Width </label>
                                        <span>{singleLogisticsContainerTypeData[0]?.Width || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Height </label>
                                        <span>{singleLogisticsContainerTypeData[0]?.Height || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Tare </label>
                                        <span>{singleLogisticsContainerTypeData[0]?.TareWeight || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Payload </label>
                                        <span>{singleLogisticsContainerTypeData[0]?.Payload || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>RTMS Category  </label>
                                        <span>{singleLogisticsContainerTypeData[0]?.RTMSCategoryType || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Product Category </label>
                                        <span>{singleLogisticsContainerTypeData[0]?.ProductCategory || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        <span>{singleLogisticsContainerTypeData[0]?.Status || "NA"}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewContainerTypeModal;